// Supabase API Client - centralized access to all API functionality
import { supabase } from '@/lib/supabase'
import * as entities from './entities'
import * as functions from './functions'
import * as integrations from './integrations'
import { Feedback } from './feedback'

// Main API client object with all functionality
export const apiClient = {
  // Direct access to Supabase client
  supabase,
  
  // Entity access
  entities,
  
  // Function access
  functions,
  
  // Integration access
  integrations,
  
  // Shorthand entity access for convenience
  Camp: entities.Camp,
  Booking: entities.Booking,
  SocialPoll: entities.SocialPoll,
  FriendConnection: entities.FriendConnection,
  UserProgram: entities.UserProgram,
  User: entities.User,
  Feedback: Feedback,
  
  // Authentication helpers
  auth: {
    signUp: entities.User.signUp,
    signIn: entities.User.signIn,
    signOut: entities.User.signOut,
    getUser: entities.User.me,
    updateProfile: entities.User.updateProfile
  },
  
  // Common functions
  getUserLocation: functions.getUserLocation,
  searchCamps: functions.searchCamps,
  getCampRecommendations: functions.getCampRecommendations,
  
  // File management
  uploadFile: integrations.UploadFile,
  uploadPrivateFile: integrations.UploadPrivateFile,
  createFileSignedUrl: integrations.CreateFileSignedUrl,
  getUserFiles: integrations.GetUserFiles,
  deleteFile: integrations.DeleteFile,
  
  // AI/LLM functions
  invokeLLM: integrations.InvokeLLM,
  generateImage: integrations.GenerateImage,
  extractDataFromFile: integrations.ExtractDataFromUploadedFile,
  
  // Email
  sendEmail: integrations.SendEmail,
  
  // Google Calendar
  calendar: {
    startAuth: functions.startGoogleCalendarAuth,
    handleCallback: functions.googleCalendarCallback,
    getEvents: functions.getCalendarEvents,
    disconnect: functions.disconnectGoogleCalendar
  },
  
  // Health check
  healthCheck: integrations.Core.healthCheck,
  getConfig: integrations.Core.getConfig
};

// Legacy export for backward compatibility - remove when all imports are updated
export const base44 = apiClient;

// Export individual modules for direct access
export { entities, functions, integrations };

// Default export for compatibility with default imports
export default apiClient;
